




















































import { Vue, Component } from "vue-property-decorator"
import Roles from "@/components/Roles.vue"
import { signOut } from "@/services/auth"
import { currentUserIs, UserRole } from "@/types/Users"
import ClipboardCopy from '@/components/ClipboardCopy.vue'

@Component({
  components: {
    Roles,
    ClipboardCopy
  },
  metaInfo: {
    title: 'Settings - Me'
  }
})
export default class Me extends Vue {
  get me() {
    return this.$store.getters.me
  }

  get userIsAdmin() {
    return currentUserIs(UserRole.Admin)
  }

  signOut() {
    signOut(this.$store)
  }

}
